<template>
    <BaseWidget v-bind="$attrs" :widget="meta" :loading="loading">
        <div class="dw-astats-body">
            <div class="dw-astats-hero">
                <span class="dw-astats-hero-num" :style="{ color: barColor }">%{{ percent }}</span>
                <span class="dw-astats-hero-lbl">Toplam Kullanılan</span>
            </div>
            <div class="dw-astats-bar-section">
                <div class="dw-astats-bar dw-storage-simple-bar-track">
                    <div class="dw-storage-simple-bar-fill" :style="{ width: percent + '%', background: barColor }"></div>
                </div>
            </div>
            <div class="dw-metrics">
                <div class="dw-metric">
                    <i class="bi bi-hdd-fill" :style="{ color: barColor }"></i>
                    <div class="dw-metric-text">
                        <span class="dw-metric-val">{{ apiData?.used_text || '—' }}</span>
                        <span class="dw-metric-lbl">Kullanılan</span>
                    </div>
                </div>
                <div class="dw-metric-sep"></div>
                <div class="dw-metric">
                    <i class="bi bi-hdd" style="color: var(--bs-success)"></i>
                    <div class="dw-metric-text">
                        <span class="dw-metric-val">{{ apiData?.total_text || '—' }}</span>
                        <span class="dw-metric-lbl">Toplam</span>
                    </div>
                </div>
            </div>
        </div>
    </BaseWidget>
</template>

<script>
import BaseWidget from '../BaseWidget.vue';
import widgetMixin from '../widgetMixin';

export const meta = {
    id: 'storage_simple',
    titleKey: 'common.dashboard.widgetTitles.storage_simple',
    icon: 'bi-hdd',
    accent: '#3B82F6',
    accentBg: 'rgba(59, 130, 246, 0.12)',
    glassRgb: '59, 130, 246',
    defaultCol: 1,
    defaultRow: 1,
    source: { type: 'statistics', key: 'storage' },
};

export default {
    name: 'StorageSimpleWidget',
    components: { BaseWidget },
    mixins: [widgetMixin],
    data() {
        return { meta };
    },
    computed: {
        percent() {
            return Math.round(this.apiData?.usage_percent || 0);
        },
        barColor() {
            const p = this.percent;
            if (p < 60) return 'var(--bs-success)';
            if (p < 80) return 'var(--bs-warning)';
            return 'var(--bs-danger)';
        },
    },
};
</script>
